import React from 'react'
import styles from './ThePageWrapper.module.scss'

const ThePageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => <>
  <div className={styles['page-wrapper']}>
    {children}
  </div>
</>

export default ThePageWrapper
